import connect from '../axios/axios.auth';

const masterFunction =  {
  ordenesEntrega: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/ordenes-entrega`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  register: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/`, { data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  update: (data) => {
    return new Promise((resolve, reject) => {
      connect.put(`/master/`, { data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  listado: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/master/`)
      .then((response) => {
        resolve(response.data.list)
      })
    })
  },
  listadocomplete: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/master/complete/`)
      .then((response) => {
        resolve(response.data.list)
      })
    })
  },
  listadoFiltro: (data = null) => {
    return new Promise((resolve, reject) => {
      const value = data ? `/${data}` : '';
      connect.get(`/master/filtro${value}`)
      .then((response) => {
        resolve(response.data.list)
      })
    })
  },
  estadosMaster: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/estados`, data)
      .then((response) => {
        resolve(response)
      })
    })
  },
  cambioEstadosMaster: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/cambio`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  cierreGuiaMaster: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/cierre`, data)
      .then((response) => {
        resolve(response.data.resultado);
      })
    })
  },
  transferenciaData: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/transferencia`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  removerMaster: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/remover`, data)
      .then((response) => {
        resolve(response)
      })
    })
  },
}

export default masterFunction;